import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Color } from 'ng2-charts';
import { GastosService } from '../../services/gastos.service';
import { SucursalesService } from '../../services/sucursales.service';
import { DatesHelpersService } from '../../services/tools/dates-helpers.service';
import { HelpersService } from '../../services/tools/helpers.service';
//PDF
import * as jsPDF from 'jspdf';
import * as _html2canvas from "html2canvas";
import { CategoriasGastosService } from '../../services/categorias-gastos.service';

const html2canvas: any = _html2canvas;
declare const require: any;
require('jspdf-autotable');

@Component({
  selector: 'app-gastos-detallados-categoria',
  templateUrl: './gastos-detallados-categoria.component.html',
  styleUrls: ['./gastos-detallados-categoria.component.scss']
})
export class GastosDetalladosCategoriaComponent implements OnInit {

  public isLoading: boolean = false;
  public fechaInicio: string = null;
  public fechaFin: string = null;
  public sucursales: any[] = [];
  public sucursal: any = {id:null};
  public sucursalPorDefecto: string = "";
  public gastosCategorias : any[]; //Aqui estan todos los datos de categorias y se definen variables
  public gastos: any[];
  //Categorias
  public categoria: any = {id:null};
  public categoriasOpc: any[] = [];
  public categoriaPorDefecto: string = "";
  //Graficas
  //Barras
  // Register the plugin to all charts:

  public barChartOptions: ChartOptions = {
    responsive: true,
    scales: { xAxes: [{}], yAxes: [{}] }

  };

  public barChartLabels: string[];
  public barChartType: ChartType;
  public barChartLegend = true;
  public barChartData: ChartDataSets[];
  public barChartColors: Color[] = [ { backgroundColor: [] }];
  public muestraBarras: boolean = false;
  
  public chartClicked(e:any): void {
    try {
      
    } catch (err) {}
  }
  public chartHovered(e:any): void {
    console.log(e);
  }
  constructor(
    private helperService : HelpersService,
    private service : GastosService,
    private sucursalesService : SucursalesService,
    private datesHelper : DatesHelpersService,
    private router : Router,
    private categoriasService: CategoriasGastosService,
  ) { }

  ngOnInit() {
    let defaultDates = this.datesHelper.getMonthDate();
    let yearDefault = defaultDates.fechaInicio.split("-")[0];
    // this.fechaInicio = defaultDates.fechaInicio;
    this.fechaInicio = (yearDefault+"-"+"01-01");
    //console.log("Fecha Inicio: ", this.fechaInicio);
    this.fechaFin = defaultDates.fechaFin;
    this.getSucursales();
    this.getCategorias();
    this.getGastosPorCategoria();
    //this.getGastosPorMes();
  }

  //Get gastos por categoría
  public getGastosPorCategoria(){
    this.barChartLabels = [];
    this.barChartType = 'bar';
    this.barChartLegend = false;
    this.barChartData = [ { data: [] } ];
    this.barChartColors = [ { backgroundColor: '#ff8900' }];
    this.muestraBarras = false;

    let filters = {
      "start-date": this.fechaInicio,
      "end-date": this.fechaFin
    }
    if (this.sucursal.id) {
      filters["idSucursales"] = this.sucursal.id;
    }
    if (this.categoria.id) {
      filters["idCategoriasGastos"] = this.categoria.id;
    }

    console.log("Filters: ", filters);
    
    this.isLoading = true;
    var barDataTemp: Array <number> = [];
    this.service.getGastosByCategory(filters).subscribe((response)=>{
      const jsonResult = response.json();
      this.gastosCategorias = jsonResult;
      console.log("Gastos categorías: ", this.gastosCategorias);
      this.gastosCategorias.forEach(gastoMes => {
        //Array para obtener el monto total de las categorias por el mes seleccionado
        this.barChartLabels.push(gastoMes.mes);
        barDataTemp.push(gastoMes.total);
      });
      this.isLoading = false;
      this.barChartData[0].data = barDataTemp;
      //Validacion cuando el ultimo dato es cero
      // if(barDataTemp[barDataTemp.length-1] === 0){
      //   this.barChartLabels.pop();
      //   barDataTemp.length = barDataTemp.length -1;
      //   this.barChartData[0].data = barDataTemp;
      // }else{
      //   this.barChartData[0].data = barDataTemp;
      // }
      //Comprobamos si se tienen datos para graficar
      if (this.barChartData.length === 0){ //Comprueba que el dataset tenga datos para graficar
        this.muestraBarras = false;
      }else{
        this.muestraBarras = true;
      }
    }, error => {
      this.isLoading = false;
      // se resuelven los errores 403 y 500
      this.helperService.httpGlobalError(error, false);

      if (error.status == 400 || error.status == 500) {
        this.helperService.notification('ERROR', 'Sucedió un error al obtener el listado de gastos por mes. Por favor, intenta más tarde.', 'error');
      }
    });
  }

  // Get categorias
  getCategorias(){
    this.isLoading = true;
    this.categoriasService.getSelect().subscribe(
      (response)=>{
        const jsonResult = response.json();
        if(jsonResult.content){
          this.categoriasOpc = jsonResult.content;
          console.log("Categorías: ", this.categoriasOpc);
          if (this.categoriasOpc.length>1){
            this.categoriaPorDefecto = "Seleccione";
          } else if(this.categoriasOpc.length>0){
            this.categoria =  this.categoriasOpc[0];
          }
          //this.getGastos();
          this.isLoading = false;
        }

        this.categoriasOpc = response.json().content;
      }, error => {
        this.isLoading = false;

        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);

        if (error.status == 400 || error.status == 500) {
          this.helperService.notification('ERROR', 'Sucedió un error obtener el listado de categorías. Por favor, intenta más tarde.', 'error');
        }
    });
  }
  //Get sucursales
  private getSucursales(){
    this.isLoading = true;
    this.sucursalesService.getSelect().subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        if(jsonResult.content){
          this.sucursales = jsonResult.content;
          console.log("Sucursales: ", this.sucursales);
          if (this.sucursales.length>1){
            this.sucursalPorDefecto = "Seleccione";
          } else if(this.sucursales.length>0){
            this.sucursal =  this.sucursales[0];
          }
          //this.getGastos();
          this.isLoading = false;
        }

      }, error =>
      {
        // se resuelve error 403 y 500
        this.isLoading = false;
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  sucursalChanged(sucursal){
    if(sucursal){
      this.sucursal = sucursal;
      this.getGastosPorCategoria();
    }
  }

  categoriasChanged(categoria){
    if(categoria){
      this.categoria = categoria;
      this.getGastosPorCategoria();
    }
  }

  //Imprimir pdf

  public downloadPDF() {
    this.isLoading=true;
    // Extraemos el
    const DATA = document.getElementById('htmlData');
    //const jsPDF = require('jspdf')
    const doc = new jsPDF('l');
    const options = {
      background: 'white',
      scale: 3
    };
    html2canvas(DATA, options).then((canvas) => {

      const img = canvas.toDataURL('image/jpg');
      // Add image Canvas to PDF
      const bufferX = 15;
      const bufferY = 15;
      const imgProps = (doc as any).getImageProperties(img);
      const pdfWidth = doc.internal.pageSize.getWidth() - 2 * bufferX;
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      doc.addImage(img, 'JPEG', bufferX, bufferY, pdfWidth, pdfHeight, undefined, 'FAST');
      return doc;
    }).then((docResult) => {
      this.isLoading=false;
      if(this.categoria.nombre){
        docResult.save("Reporte_"+this.categoria.nombre+"del"+this.fechaInicio+"al"+this.fechaFin);
      }else{
        docResult.save("Reporte_Gastos");
      }
    });
  }



}



// WEBPACK FOOTER //
// ./src/app/gastos/gastos-detallados-categoria/gastos-detallados-categoria.component.ts